<template>
  <div>
    <div
      class="contentStyleBody"
    >
      <div
        class="contentStyleBodyEl"
      >
        <div class="rightContent">
          <div class="rightContentBorder" />
          <div
            class="d-flex align-center mLeft"
            @click="showData(PricingPeriod.id)"
          >
            <v-icon
              v-if="show[PricingPeriod.id]"
              large
              color="primary"
            >
              mdi-menu-down
            </v-icon>
            <v-icon
              v-else
              large
              color="primary"
            >
              mdi-menu-right
            </v-icon>
          </div>
          <div class="d-flex align-center rightContentText">
            <div class="pricingPeriod">
              <div>
                {{ $t('billing.filter.from') }}
                <span>{{ dateFormat(PricingPeriod.startDate) }}</span>
                {{ $t('billing.filter.to') }}
                <span>{{ dateFormat(PricingPeriod.endDate) }}</span>
              </div>
              <div
                v-if="PricingPeriod.color"
                class="pricingPeriodPoint"
              />
              <div
                v-if="PricingPeriod.active"
                class="pricingPeriodCurrent"
              >
                {{ $t('aquassistBilling.pricingManagement.labels.currentPeriod') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="show[PricingPeriod.id]"
        class="AquassistManagePadding"
      >
        <AquassistManage
          :items="PricingPeriod"
          modeEdit
        />
      </div>
    </div>
  </div>
</template>

<script>
import AquassistManage from '@/views/admin/aquassistBilling/pricingManagementDetails/AquassistManage.vue';
import moment from 'moment/moment';
import { mapGetters } from 'vuex';

export default {
    name: 'PriceUpdateInfos',
    components: { AquassistManage },
    props: {
        listManage: {
            type: Array,
            default: () => {},
        },
        managedName: {
            type: String,
            default: '',
        },
        PricingPeriod: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            show: {},
        };
    },

    watch: {
        '$store.getters.pricingPeriodData': {
            handler(newData, oldData) {
                if (newData !== oldData) {
                    this.updateData();
                }
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters([
            'userLang',
            'pricingPeriodData',
        ]),
    },
    created() {
        this.emitChange();
    },

    methods: {
        dateFormat(date) {
            return moment.utc(date).locale(this.userLang).format('L');
        },
        showData(item) {
            this.show = {
                ...this.show,
                [item]: !this.show[item],
            };
        },
        emitChange() {
            this.$emit('inputChange', () => true);
        },
        updateData() {
            this.$emit('sendData', this.pricingPeriodData);
        },
    },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/pricingManagement.scss";
@import "@/assets/styles/massBalanceStyle.scss";
</style>
